import React from 'react'
import {Input, TitleText} from '../../../common'
import {EMAIL_REGEX} from '../../../../utils/constants'
import {i18n} from '../../../../i18n'
import {EditClientKey} from '../utils/keys'

type supportFieldKey = (typeof EditClientKey)[keyof typeof EditClientKey]

interface EditDigitalSupportProps {
    extractProps: (fieldKey: supportFieldKey) => any
}

const EditDigitalSupportSection: React.FC<EditDigitalSupportProps> = ({extractProps}) => {
    return (
        <div>
            <TitleText text={i18n.t('userDataTab.header.digitalSupport')} />
            <div style={{marginTop: 12, marginBottom: 12}}>{i18n.t('userDataTab.digitalSupport.explanation')}</div>
            <Input type='checkbox' label={i18n.t('userDataTab.digitalSupport.approval')}  {...extractProps(EditClientKey.digitalSupport)}/>
            <Input
                label={i18n.t('userDataTab.digitalSupport.email.title')}
                extraInfo={i18n.t('userDataTab.digitalSupport.email.extra')}
                regex={EMAIL_REGEX}
                {...extractProps(EditClientKey.email)}
                disabled={extractProps(EditClientKey.digitalSupport).value === false || extractProps(EditClientKey.digitalSupport).value == null}
            />
        </div>
    )
}

export default EditDigitalSupportSection
